"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectVersions = void 0;
exports.isV1 = isV1;
exports.isV2 = isV2;
exports.assertV2 = assertV2;
/**
 * Project version gating for the Work Packets feature.
 *
 * `project.version` partitions all projects into:
 *   - v1: the classic microtask pipeline (the only behavior before Work Packets shipped).
 *   - v2: the Work Packets pipeline.
 *
 * Every code path that diverges between v1 and v2 must route through `isV2` (or `isV1`)
 * so that backward compatibility is preserved for every existing project.
 *
 * See `server/prds/work-packets/work-packets-prd.md` for design and
 * `server/prds/work-packets/implementation-plan.md` (PR 1) for the rollout plan.
 */
exports.projectVersions = ['V1', 'V2'];
function isV1(project) {
    return project.version === 'V1';
}
function isV2(project) {
    return project.version === 'V2';
}
/**
 * Throws if `project` is not a v2 project. Use at the top of v2-only code paths
 * to surface mis-routed v1 traffic as a loud error rather than silent corruption.
 */
function assertV2(project) {
    if (!isV2(project)) {
        throw new Error(`Expected v2 project, got version=${project.version}`);
    }
}
//# sourceMappingURL=Version.js.map